// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapstate-mgr {
    width: 100%;
}
.mapstate-mgr > .mapstate-mgr-form {
    display: flex;
    align-items: stretch;
    margin-top: 10px;
    justify-content: space-between;
}
.mapstate-mgr input {
    min-width: 75%;
    flex-grow: 1;
    border: 1px solid #bbb;
    border-width: 1px 0 1px 1px;
}
.mapstate-mgr-list div {
    margin-left: 20px;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: 1px 0;
}
.mapstate-mgr-list .icon {
    color: #bbb;
}
.mapstate-mgr-list .icon:hover {
    color: red;
    cursor: pointer;
}
.mapstate-mgr-list .name {
    cursor: pointer;
}
.mapstate-mgr-toggle {
    display: flex;
    padding: 2px 0;
}
`, "",{"version":3,"sources":["webpack://./js/style/MapStateMgr.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,cAAc;AAClB","sourcesContent":[".mapstate-mgr {\n    width: 100%;\n}\n.mapstate-mgr > .mapstate-mgr-form {\n    display: flex;\n    align-items: stretch;\n    margin-top: 10px;\n    justify-content: space-between;\n}\n.mapstate-mgr input {\n    min-width: 75%;\n    flex-grow: 1;\n    border: 1px solid #bbb;\n    border-width: 1px 0 1px 1px;\n}\n.mapstate-mgr-list div {\n    margin-left: 20px;\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n    padding: 1px 0;\n}\n.mapstate-mgr-list .icon {\n    color: #bbb;\n}\n.mapstate-mgr-list .icon:hover {\n    color: red;\n    cursor: pointer;\n}\n.mapstate-mgr-list .name {\n    cursor: pointer;\n}\n.mapstate-mgr-toggle {\n    display: flex;\n    padding: 2px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
